import React, { useState, useEffect, useCallback } from "react";
import api from "../../common/lib/api";
import numeral from "numeral";
import Errors, { useError } from "../../common/components/Errors";
import { Spinner } from "@blueprintjs/core";
import naturalCompare from "natural-compare";
import { IS_IN_DEV_MODE } from "../../constants";

function multiNaturalCompare(...fields) {
  return (a, b) => {
    for (const field of fields) {
      const av = a[field];
      const bv = b[field];
      if (field === "atlasCategory") {
        console.log(av, bv);
      }
      if (!av && bv) {
        return 1;
      }
      if (av && !bv) {
        return -1;
      }
      if (av && bv) {
        const avv = av.toString().toLowerCase();
        const bvv = bv.toString().toLowerCase();
        if (!avv && bvv) {
          return 1;
        }
        if (avv && !bvv) {
          return -1;
        }
        if (avv !== bvv) {
          return naturalCompare(avv, bvv);
        }
      }
    }
    return 0;
  };
}

export default function Page() {
  const [saleItems, setSaleItems] = useState({
    status: "init",
    data: [],
  });
  const { errors, setErrors, handleError } = useError();

  const load = useCallback(async () => {
    try {
      const data = await api.get("/sale-items").then((x) => x.data.data);

      const bySystem = {};

      for (const item of data) {
        const systems = (item.category || "None").split(",");
        for (const system of systems) {
          bySystem[system] = bySystem[system] || [];
          bySystem[system].push({
            ...item,
            system,
          });
        }
      }

      Object.values(bySystem).forEach((items) =>
        items.sort(
          multiNaturalCompare(
            "connector",
            "subcategory",
            "saleItemId",
            "unitPrice",
            "description"
          )
        )
      );

      setSaleItems({
        data: bySystem,
        status: "ready",
      });
    } catch (e) {
      setSaleItems((current) => ({
        ...current,
        status: "error",
      }));
      handleError(e);
    }
  }, [handleError]);

  useEffect(() => {
    load();
  }, [load]);

  if (saleItems.status === "init") {
    return <Spinner size="200" />;
  }

  return (
    <>
      <h1>Items For Sale</h1>

      {errors.length > 0 && (
        <Errors.Callout errors={errors} setErrors={setErrors} />
      )}

      {Object.entries(saleItems.data).map(([system, items]) => {
        return (
          <>
            <h2>{system}</h2>
            <table className="bp3-html-table bp3-html-table-bordered bp3-html-table-condensed bp3-html-table-striped">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Country</th>
                  <th>Item</th>
                  <th>$</th>
                </tr>
              </thead>
              <tbody>
                {items.map((saleItem) => {
                  return <LinkRow key={saleItem.itemId} saleItem={saleItem} />;
                })}
              </tbody>
            </table>
          </>
        );
      })}
    </>
  );
}

function LinkRow({ saleItem }) {
  return (
    <tr>
      <td>
        {saleItem.subcategory}
      </td>
      <td style={{ whiteSpace: "nowrap" }}>{saleItem.connector}</td>
      <td>
        <strong>{saleItem.saleItemId}</strong> - {saleItem.name}
        <div className="bp3-text-small">{saleItem.description}</div>
        {IS_IN_DEV_MODE && (
          <strong className="bp3-text-small">
            {JSON.parse(saleItem.raw).UID}
          </strong>
        )}
      </td>
      <td style={{ textAlign: "right" }}>
        ${numeral(saleItem.unitPrice).format("0,0.00")}
      </td>
      
    </tr>
  );
}
